module.exports = __webpack_public_path__ + "img/Charles Yates at Graduation, 1958 .54b3082b.jpg";